export default __webpack_public_path__ + "static/2380-3e1bc918485b0fbea0a71be77775fe87.gif";